export default __webpack_public_path__ + "069f6c825706cec7b6f7645b0e76f78f.png";